import { Grid } from '@mui/material';
import { SuccessRateWidget } from './SuccessRateWidget';
import { EnergyWidget } from './EnergyWidget';
import { ActiveSessionsWidget } from './ActiveSessionsWidget';
import { UptimeWidget } from './UptimeWidget';
import { useAppSelector } from '@energy-stacks/broker/store';
import { PortalTarget } from '@energy-stacks/core/ui';
import {
  DashboardTimePicker,
  getRangeForTimePeriod,
} from '@energy-stacks/shared';
import { useState } from 'react';
import { DateRange } from '@energy-stacks/core/date-range-picker';

export const DashboardWidgetContainer = () => {
  const sidebarOpened = useAppSelector((state) => state.sidebar.sidebarOpened);
  const [dateRange, setDateRange] = useState<DateRange | undefined>(() =>
    getRangeForTimePeriod('1')
  );

  return (
    <>
      <PortalTarget targetId="ESPageHeaderStackRef">
        <DashboardTimePicker onDateRangeChange={setDateRange} />
      </PortalTarget>

      <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
        <Grid container item spacing={6} sx={{ pt: 3 }}>
          <Grid item md={6} sm={sidebarOpened ? 12 : 6} xs={12}>
            <SuccessRateWidget
              startDate={dateRange?.startDate}
              endDate={dateRange?.endDate}
            />
          </Grid>
          <Grid item md={6} sm={sidebarOpened ? 12 : 6} xs={12}>
            <EnergyWidget
              startDate={dateRange?.startDate}
              endDate={dateRange?.endDate}
            />
          </Grid>
          <Grid item md={6} sm={sidebarOpened ? 12 : 6} xs={12}>
            <ActiveSessionsWidget
              startDate={dateRange?.startDate}
              endDate={dateRange?.endDate}
            />
          </Grid>
          <Grid item md={6} sm={sidebarOpened ? 12 : 6} xs={12}>
            <UptimeWidget
              startDate={dateRange?.startDate}
              endDate={dateRange?.endDate}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
